import {
  GET_VPP_REGISTRATION_LIST_REQUEST,
  GET_VPP_REGISTRATION_LIST_SUCCESS,
  GET_VPP_REGISTRATION_LIST_FAILURE,
  GET_VPP_REGISTRATION_DETAILS_REQUEST,
  GET_VPP_REGISTRATION_DETAILS_SUCCESS,
  GET_VPP_REGISTRATION_DETAILS_FAILURE,
  POST_VPP_REGISTRATION_CREATE_REQUEST,
  POST_VPP_REGISTRATION_CREATE_SUCCESS,
  POST_VPP_REGISTRATION_CREATE_FAILURE,
  VPP_REGISTRATION_UPDATE_REQUEST,
  VPP_REGISTRATION_UPDATE_SUCCESS,
  VPP_REGISTRATION_UPDATE_FAILURE,
  VPP_REGISTRATION_DELETE_REQUEST,
  VPP_REGISTRATION_DELETE_SUCCESS,
  VPP_REGISTRATION_DELETE_FAILURE,
  GET_LOCATION_SEARCH_REQUEST,
  GET_LOCATION_SEARCH_SUCCESS,
  GET_LOCATION_SEARCH_FAILURE,
} from "actions/vppUserRegistration";
import { getUserRole } from "constants/select";

const initialState = {
  loading: false,
  list: [],
  detail: {},
  locationOptions: [],
  locationLoading: false,
};

// Flatten owner_detail onto the row so the DataTable columns
// (Email, Name, Access Type, Enable, Status) resolve consistently.
const mapRegistration = (it) => {
  const owner = it.owner_detail || {};
  return {
    ...it,
    email: owner.email,
    first_name: owner.first_name,
    last_name: owner.last_name,
    access_type: owner.access_type,
    access_type_label: getUserRole(owner.access_type),
    enabled: owner.enabled,
    owner_status: owner.status,
    value: it.id,
    label: owner.email,
  };
};

export default function vppUserRegistration(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_VPP_REGISTRATION_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_VPP_REGISTRATION_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: (payload || []).map(mapRegistration),
      };
    }

    case GET_VPP_REGISTRATION_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
        list: [],
      };
    }

    case GET_VPP_REGISTRATION_DETAILS_REQUEST:
    case POST_VPP_REGISTRATION_CREATE_REQUEST:
    case VPP_REGISTRATION_UPDATE_REQUEST:
    case VPP_REGISTRATION_DELETE_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case POST_VPP_REGISTRATION_CREATE_SUCCESS:
    case VPP_REGISTRATION_UPDATE_SUCCESS:
    case VPP_REGISTRATION_DELETE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }

    case GET_VPP_REGISTRATION_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        detail: mapRegistration(payload),
      };
    }

    case GET_VPP_REGISTRATION_DETAILS_FAILURE: {
      return {
        ...state,
        loading: false,
        detail: {},
      };
    }

    case POST_VPP_REGISTRATION_CREATE_FAILURE:
    case VPP_REGISTRATION_UPDATE_FAILURE:
    case VPP_REGISTRATION_DELETE_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case GET_LOCATION_SEARCH_REQUEST: {
      return {
        ...state,
        locationLoading: true,
      };
    }

    case GET_LOCATION_SEARCH_SUCCESS: {
      return {
        ...state,
        locationLoading: false,
        locationOptions: (payload || []).map((it) => ({
          ...it,
          label: `${it.city} ${it.state_code}`,
        })),
      };
    }

    case GET_LOCATION_SEARCH_FAILURE: {
      return {
        ...state,
        locationLoading: false,
        locationOptions: [],
      };
    }

    default:
      return state;
  }
}
